import { Component, Input, Output, EventEmitter, OnInit, OnChanges, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { AttendenceExportService } from '../../attendance-export.service';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-attendance-inout',
  standalone: false,
  templateUrl: './attendance-inout.component.html',
  styleUrls: ['./attendance-inout.component.scss']
})
export class AttendanceInoutComponent implements OnInit, OnChanges {
  isHandset: boolean = false;
  showExportProceedComponent: boolean = false;
  exportedData: any;
  
  @Input() proceedData: any;
  @Input() attendanceHeader: any;
  @Output() proceed = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  @ViewChild('attendanceTable') attendanceTable!: ElementRef<HTMLTableElement>;

  groupedAttendance: any[] = [];

  constructor(
    private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private router: Router,
    private attendenceExportService: AttendenceExportService
  ) { }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      this.isHandset = state.matches;
    });
    
    // Fallback to sessionStorage if input not provided
    if (!this.attendanceHeader) {
      const raw = sessionStorage.getItem('attendance_export_header');
      if (raw) {
        try {
          this.attendanceHeader = JSON.parse(raw);
        } catch { }
      }
    }
    
    if (this.proceedData?.data?.employee_attendance) {
      this.groupedAttendance = this.groupAttendanceData(this.proceedData.data.employee_attendance);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['proceedData'] && !changes['proceedData'].firstChange) {
      if (this.proceedData?.data?.employee_attendance) {
        this.groupedAttendance = this.groupAttendanceData(this.proceedData.data.employee_attendance);
      }
    }
  }

  groupAttendanceData(attendance: any[]) {
    const shops: { [shop: string]: any } = {};
    attendance.forEach(emp => {
      if (!shops[emp.shopname]) {
        shops[emp.shopname] = {
          shopname: emp.shopname,
          noClockOut: [],
          notFinalized: []
        };
      }
      if (!emp.shift_end_time) {
        shops[emp.shopname].noClockOut.push(emp);
      } else {
        shops[emp.shopname].notFinalized.push(emp);
      }
    });
    return Object.values(shops);
  }

  onBack() {
    this.back.emit();
  }

  getRowNumber(shopIdx: number, rowIdx: number, type: 'noClockOut' | 'notFinalized'): number {
    let count = 0;
    for (let i = 0; i < shopIdx; i++) {
      count += this.groupedAttendance[i].noClockOut.length + this.groupedAttendance[i].notFinalized.length;
    }
    if (type === 'notFinalized') {
      count += this.groupedAttendance[shopIdx].noClockOut.length;
    }
    return count + rowIdx + 1;
  }

  copyTable() {
    const table = this.attendanceTable?.nativeElement;
    if (!table) return;

    // Try using the modern Clipboard API
    if (navigator.clipboard && (window as any).ClipboardItem) {
      const blob = new Blob([table.outerHTML], { type: 'text/html' });
      const clipboardItem = new (window as any).ClipboardItem({ 'text/html': blob });
      (navigator.clipboard as any).write([clipboardItem]).then(() => {
        this.snackBarService.openSnackBar({
          type: 'success',
          title: 'Copied',
          message: 'Table copied with formatting!'
        });
      }).catch(() => {
        this.snackBarService.openSnackBar({
          type: 'error',
          title: 'Copy Failed',
          message: 'Could not copy table.'
        });
      });
    } else {
      // Fallback for older browsers
      const listener = (e: ClipboardEvent) => {
        e.clipboardData?.setData('text/html', table.outerHTML);
        e.clipboardData?.setData('text/plain', table.innerText);
        e.preventDefault();
      };
      document.addEventListener('copy', listener);
      document.execCommand('copy');
      document.removeEventListener('copy', listener);
      this.snackBarService.openSnackBar({
        type: 'success',
        title: 'Copied',
        message: 'Table copied to clipboard!'
      });
    }
  }

  onExportAnyway() {
    // Emit to parent to handle the proceed logic
    this.proceed.emit();
  }
}
